import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { getType } from "../../actions/studensts";
import UNAUTHORIZED from "../UNAUTHORIZED";
import StudentList from "../StudentList";

export default function Print() {
  const dispatch = useDispatch();
  const location = useLocation();
  const studentType = location.pathname.split("/")[3];
  const { students } = useSelector((state) => state.students);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const count = useSelector((state) => state.students.count);
  const user = JSON.parse(localStorage.getItem("profile")).value[0].role;

  useEffect(() => {
    dispatch({ type: "CLEAR" });
    if (!hasSearched) return;
    const state = convertType(studentType);
    const timeOutId = setTimeout(() => {
      dispatch(getType("print", state, search));
    }, 500);
    return () => clearTimeout(timeOutId);
  }, [location, search, dispatch, studentType, hasSearched]);

  useEffect(() => {
    setHasSearched(false);
  }, [location]);

  useEffect(() => {
    setLoading(!students);
  }, [students]);

  return (
    <div>
      {!["admin", "auditor", "agent"].includes(user) ? (        <UNAUTHORIZED />
      ) : (
        <div>
          <h1 className="text-2xl pt-0 pl-6 pb-5 text-white">
            {studentType === "new"
              ? "New Print"
              : studentType === "print_validation"
              ? "Print Validation"
              : ""}
          </h1>
          <div className="flex justify-center">
            <div className="lg:w-3/5 md:w-3/4 w-full min-h-screen border shadow flex flex-col bg-white p-6 rounded-lg">
              <StudentList
                setSearch={(val) => {
                  setSearch(val);
                  setHasSearched(true);
                }}
                students={students}
                search={search}
                loading={loading}
                count={count}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function convertType(studentType) {
  switch (studentType) {
    case "new":
      return "print";
    case "print_validation":
      return "print_validation";
    default:
      return "print";
  }
}
